import { useContext } from "react";
import TextBox from "../Components/TextBox";
import TextBoxMobileView from "../Components/TextBoxMobileView";
import { TextPropsTypes } from "../TextPropsTypes";
import { CheckResponsiveContext } from "../../../Context/CheckResponsiveContext";

function TextBoxContainer({
  questionId,
  surveyAnswers,
  isPreview,
  setSurveyAnswers,
  surveyAnswersInfo,
  mainRefObject,
}: TextPropsTypes) {
  const { isMobile } = useContext(CheckResponsiveContext);
  const handleChangeInputSingleText: TextPropsTypes["handleChangeInputSingleText"] =
    (questionId, e) => {
      const { value } = e.target;
      setSurveyAnswers((draft: TextPropsTypes["surveyAnswers"]) => {
        draft[questionId] = draft[questionId] || {};
        if (!value.trim()) {
          if (
            draft?.[questionId]?.comment?.length ||
            draft?.[questionId]?.uploads?.length
          ) {
            delete draft[questionId]["val"];
          } else {
            delete draft[questionId];
          }
        } else {
          draft[questionId]["val"] = value;
        }
      });
    };

  return (
    <>
      {isMobile ? (
        <TextBoxMobileView
          surveyAnswers={surveyAnswers}
          handleChangeInputSingleText={handleChangeInputSingleText}
          isPreview={isPreview}
          questionId={questionId}
          surveyAnswersInfo={surveyAnswersInfo}
        />
      ) : (
        <TextBox
          surveyAnswers={surveyAnswers}
          handleChangeInputSingleText={handleChangeInputSingleText}
          isPreview={isPreview}
          questionId={questionId}
          surveyAnswersInfo={surveyAnswersInfo}
        />
      )}
    </>
  );
}

export default TextBoxContainer;
